import * as React from 'react';
import * as moment from 'moment';

import { IEvent } from '../../classes/event';
import { IShowPosterInfo } from '../../classes/showposterinfo';
import { ICalendarAppBaseText } from '../../classes/buytickets-text';
import { connect } from 'react-redux';
import ListContainerView from '../../views/buy-tickets-list-container.view';
import { IBuyTicketsAppState } from '../../redux-state';

interface IListContainerExternalProps {

}

interface StateToProps {
    currentMoment: moment.Moment;
    eventCount: number;
    text: ICalendarAppBaseText;
    events: IEvent[];
    showMore: Function;
    itemToHideCssClass: string;
    itemsToShow: number;
    thumbnailImage: string;
    showPosterInfo: IShowPosterInfo;
}

export type ListContainerProps = IListContainerExternalProps & StateToProps;

export const ListContainerBase: React.StatelessComponent<ListContainerProps> = props => {
        return (
            <ListContainerView {...props} />
        )
}

function mapStateToProps(state: IBuyTicketsAppState, ownProps: IListContainerExternalProps): StateToProps {
    const itemToHideCssClass = "buy-tickets-list-item-hide";
    let imageUrl = "";
    if ( state.calendar.events.length > 0)
        imageUrl = state.calendar.events[0].thumbnail;
    return {
        currentMoment: state.calendar.currentDate,
        eventCount: state.calendar.events.length,
        text: state.calendarText,
        events: state.calendar.events,
        itemToHideCssClass: itemToHideCssClass,
        itemsToShow: 7,
        thumbnailImage: imageUrl,
        showPosterInfo: state.calendar.showPosterInfo,
        showMore: function (e) {
            Array.prototype.slice.call(document.querySelectorAll(`.${itemToHideCssClass}`)).forEach(item => {
                item.classList.remove(itemToHideCssClass);
            });
            e.target.classList.add('hide');
            document.getElementById('buyTicketsList').tabIndex = -1;
            document.getElementById('buyTicketsList').focus();
        }
    }
}

export default connect(mapStateToProps)(ListContainerBase);